const dataTemplate = (editor) => {

    editor.BlockManager.add('dataTemplate', {
        category: 'Built In Components',
        label: 'User Information',
        attributes: {},
        content: `
        <div class="container">
            <div>
                <button classtype='text-green' type="button" class="btn fs-2 m-3 fw-normal text-green">
                    <i class="bi bi-chevron-left"></i>Patient Data
                </button>
            </div>
            
            <div class="">

            </div>

            <div class="container">
                <div class="row col-12 justify-content-between align-items-start" dataItems="getAllCards">
                    <div class="col-12 col-xl-4"  dataitem=true>
                        <div
                        classtype='leftbar-container'
                        class="leftbar-container text-white"
                    >
    
                        <div class="body">
                            <ul class="flex-column text-white fs-3 fw-bolder h-100 py-5 px-0">
                                <li class="nav-item nav-link pointer" href="#!">
                                    <a class="d-flex align-items-center justify-content-center justify-content-md-end text-white">
                                        <span>holouser02</span>
                                        <img
                                            src="https://i.ibb.co/S5wJS5j/d18c1521c859.png"
                                            class="rounded-circle d-none d-sm-block shadow mx-3"
                                            alt="User Image"
                                            width="120"
                                            height="120"
                                        />
                                    </a>
                                    </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                <a class="d-flex align-items-center justify-content-end text-white">
                                    <span>Overview</span>
                                    <i class="bi bi-house mx-5"></i>
                                </a>
                                </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                <a class="d-flex align-items-center justify-content-end text-white">
                                    <span>Information</span>
                                    <i class="bi bi-person-lines-fill mx-5"></i>
                                </a>
                                </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                <a class="d-flex align-items-center justify-content-end text-white">
                                    <span>Goals</span>
                                    <i class="bi bi-trophy mx-5"></i>
                                </a>
                                </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                <a class="d-flex align-items-center justify-content-end text-white">
                                    <span>Logs</span>
                                    <i class="bi bi-file-text mx-5"></i>
                                </a>
                                </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                <a class="d-flex align-items-center justify-content-end text-white">
                                    <span>Questionnaires</span>
                                    <i class="bi bi-question-circle mx-5"></i>
                                </a>
                                </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                <a class="d-flex align-items-center justify-content-end text-white">
                                    <span>Assessments</span>
                                    <i class="bi bi-card-checklist mx-5"></i>
                                </a>
                                </li>
                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                    <a class="d-flex align-items-center justify-content-end text-white">
                                        <span>Data Analysis</span>
                                        <i class="bi bi-clipboard-data mx-5"></i>
                                    </a>
                                </li>

                                <li statetype='offcanvas-body--item' class="nav-item nav-link pointer offcanvas-body--item" href="#!">
                                    <a class="d-flex align-items-center justify-content-end text-white">
                                        <span>Training Plan</span>
                                        <i class="bi bi-calendar-check mx-5"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    </div>
                    <div class="col-12 col-xl-5 mr-5" dataitem=true>
                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Patient Data</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Username</h4>
                                    <h5>holouser02</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Department</h4>
                                    <h5>holo_thessaloniki</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Active</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Study Group</h4>
                                    <h5>Intervention</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Devices</h2>
                            <ul class="py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Heart Rate Monitor</h4>
                                    <h5>972878988</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Wrist Band </h4>
                                    <h5>766563267</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>SmartWatch</h4>
                                    <h5>654365725</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Diagnosis</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Stroke</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Falls</h4>
                                    <h5>No</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Long Covid</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Vestibular</h4>
                                    <h5>No</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>MCI</h4>
                                    <h5>No</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Patient History</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Diabetes</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Anxiety Disorders</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Depression</h4>
                                    <h5>No</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Symptoms</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Symptoms frequency</h4>
                                    <h5>1-3 times per week</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Vertigo</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Dizziness</h4>
                                    <h5>No</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Tendency to Fall</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Falls</h4>
                                    <h5>No falls</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Vertigo Duration</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Days</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Episodic-Hours</h4>
                                    <h5>Yes</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Episodic-Minutes</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Motion Related</h4>
                                    <h5>-</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card' class="row p-3 mb-5 overflow-auto data-card fw-normal align-items-center">
                            <h2>Clinical Examination</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Dix Hallpike</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Roll Test</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Head Thrust</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Romberg</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Step Test</h4>
                                    <h5>-</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Gaze Nystagmus</h4>
                                    <h5>-</h5>
                                </li>
                            </ul>
                        </div>

                        <div classtype='data-card2' class="row p-3 mb-5 text-white overflow-auto data-card2 fw-normal align-items-center">
                            <h2>Practitioner</h2>
                            <ul class=" py-4">
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Username</h4>
                                    <h5>holoprac01</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Role</h4>
                                    <h5>Therapist(Admin)</h5>
                                </li>
                                <li class="d-flex pb-2 flex-row justify-content-between align-items-end">
                                    <h4>Department</h4>
                                    <h5>holo_thessaloniki</h5>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        `
    })
};

export default dataTemplate;